import type { useRestoreFocusTarget } from "@fluentui/react-components";

// Exporting these variables to be shared between AppButton and AppSplitButton
type TabsterDOMAttributeName = keyof ReturnType<typeof useRestoreFocusTarget>;
export const tabsterAttributeName: TabsterDOMAttributeName = "data-tabster";
